import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    X,
    YOUTUBE
} from '@/lib/socialProfile';

export const EXCLUDED_NO_FOLLOWERS_KPIS = {
    [INSTAGRAM]: ['engagement_rate', 'reach_rate'],
    [FACEBOOK]: ['engagement_rate', 'reach_rate'],
    [LINKEDIN]: ['engagement_rate', 'impression_rate'],
    [PINTEREST]: ['engagement_rate', 'impression_rate'],
    [X]: ['engagement_rate'],
    [TIKTOK_BUSINESS]: ['engagement_rate', 'view_rate'],
    [YOUTUBE]: ['engagement_rate', 'view_rate']
} as const;

export default { EXCLUDED_NO_FOLLOWERS_KPIS };
